export default __webpack_public_path__ + "static/media/contacts_map.a0f15678.png";